export enum DiscountsRoutePathNames {
  DISCOUNTS = 'discounts',
  LIST = '',
  CREATE = 'create',
  UPDATE = ':id',
  RYST_INCENTIVES_MANAGER = 'ryst-incentives-manager',
  RYST_LOCATION_USER_MANAGEMENT = 'location-user',
  RYST_PROMO_MANAGEMENT = 'promos',
}
